export const dealTypes = [
  { value: "", label: "All" },
  { value: "1", label: "מכירה" },
  { value: "2", label: "השכרה" },
  { value: "3", label: "מסחרי" },
  { value: "4", label: "השקעה" },
  { value: "5", label: "פיתוח" },
  { value: "6", label: "פיתוח מחדש" },
];

export const propertyTypes = [
  { value: "", label: "All" },
  { value: "1", label: "דירה" },
  { value: "2", label: "דירת גן" },
  { value: "3", label: "Detached (House)" },
  { value: "4", label: "Semi Detached (Cottage)" },
  { value: "5", label: "פנטהאוז" },
  { value: "6", label: "סטודיו/לופט" },
  { value: "7", label: "דירת נופש" },
  { value: "8", label: "דירת מרתף" },
  { value: "9", label: "קומפלקס" },
  { value: "10", label: "שטח" },
  { value: "11", label: "דיור מוגן" },
  { value: "12", label: "בניין שלם" },
  { value: "13", label: "מלון" },
  { value: "14", label: "Plot" },
  { value: "15", label: "Warehouse" },
  { value: "16", label: "קבוצת רכישה" },
  { value: "17", label: "חניון" },
  { value: "18", label: "חנות" },
  { value: "19", label: "משרד" },
  { value: "20", label: "Real estate for business" },
  { value: "21", label: "Yielding Real Estate" },
  { value: "22", label: "Other" },
  { value: "23", label: "Land" }, // need to check the actuall value from api
  { value: "24", label: "Project" }, // need to check the actuall value from api
];

export const airportType = [
  {
    value: "0",
    label: "ק'מ",
  },
  {
    value: "1",
    label: "miles",
  },
];
export const buildingStatus = [
  {
    value: "",
    label: "לא צויין",
  },
  {
    value: "1",
    label: "קיים",
  },
  {
    value: "2",
    label: "בשיפוצים",
  },
  {
    value: "3",
    label: "מיועד לבניה",
  },
];
export const coinsType = [
  { value: "0", label: "לא צויין" },
  { value: "1", label: "₪" },
  { value: "2", label: "$" },
  { value: "3", label: "€" },
];
export const squareTypes = [
  { value: "0", label: "מ'ר" },
  { value: "1", label: "מ'ר" },
];
export const fullTextType = [
  { value: "0", label: "כתוב טקסט" },
  { value: "1", label: "טקסט מוגדר מראש" },
  { value: "2", label: "השאר ריק" },
];
export const parkingTypes = [
  { value: "", label: "לא צויין" },
  { value: "1", label: "מקורה" },
  { value: "2", label: "שמורה" },
  { value: "3", label: "פני השטח" },
  { value: "4", label: "חינם" },
];
export const roomsType = [
  { value: "", label: "לא צויין" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10+" },
];
export const floorsType = [
  { value: "", label: "לא צויין" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10+" },
];
export const bathsType = [
  { value: "", label: "select" },
  { value: Number("1"), label: "1" },
  { value: Number("2"), label: "2" },
  { value: Number("3"), label: "3" },
  { value: Number("4"), label: "4" },
  { value: Number("5"), label: "5" },
  { value: Number("6"), label: "6" },
  { value: Number("7"), label: "7" },
  { value: Number("8"), label: "8" },
  { value: Number("9"), label: "9" },
  { value: Number("10"), label: "10+" },
];
export const metricsType = [
  { value: Number("0"), label: "sq m." },
  { value: Number("1"), label: "sq m." },
];
